import {
  Box,
  Button,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppHeader from '../components/layout/AppHeader';
import SimpleChat from '../components/SimpleChat';
import { useAuth } from '../contexts/AuthContext';



const DashboardPage: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { conversationId } = useParams<{ conversationId?: string }>();
  const [isConversationClosed, setIsConversationClosed] = useState(false);
  const simpleChatRef = useRef<any>(null);

  return (
    <Box sx={{ height: 'var(--app-height, 100vh)', display: 'flex', flexDirection: 'column' }}>
      <AppHeader
        title="Chat"
        leftContent={
          <Button
            aria-label="SOS — crisis support"
            onClick={() => navigate('/sos')}
            sx={{
              minWidth: 0,
              px: 3,
              py: 1.25,
              bgcolor: '#B00020',
              color: '#FFFFFF',
              borderRadius: '32px',
              fontWeight: 700,
              fontSize: 16,
              lineHeight: 1,
              boxShadow: 'none',
              '&:hover': { bgcolor: '#8E001A', boxShadow: 'none' },
            }}
          >
            <Box
              sx={{
                width: 22,
                height: 22,
                borderRadius: '50%',
                bgcolor: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 0.75,
                flexShrink: 0,
                fontWeight: 900,
                fontSize: 15,
                color: '#FF0000',
                lineHeight: 1,
              }}
            >
              !
            </Box>
            SOS
          </Button>
        }
      />

      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <SimpleChat
          ref={simpleChatRef}
          onConversationStateChange={setIsConversationClosed}
          conversationId={conversationId}
        />
      </Box>
    </Box>
  );
};

export default DashboardPage;
